import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"
import { TagInput } from 'rsuite';

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { Button, Input, Tabs } from 'rsuite';
export default function EditProductsGroup() {
    const { t } = useTranslation();

    let cookie = getCookies();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);

    const [data, setData] = React.useState<any>(null);
    const save = async () => {
        try {
            var path = `${config.url}/v1/dashboard/pgroup/${Id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            Swal.fire('Update Data')
        } catch (error) {

        }
    }
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/pgroup/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData(res.data.message)
        } catch (error) {

        }
    }
    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/ProductsGroup'
        },
        {
            name: 'Products List',
            url: '/dashboard/Products/ProductsGroup'
        },
        {
            name: 'Edit Group Products',
            url: null
        }
    ]
    useEffect(() => {
        load();
    }, []);
    return (
        <div>
            <BreadCrump data={breadcrump}></BreadCrump>


            {
                data != null && <div className='grid grid-cols-1 sm:grid-cols-5'>
                    <div >

                        <div className="p-3 bg-gray-500 rounded-[10px] p-5">
                            <h4 className="text-white text-[20px]  text-right font-bold ">{t('Edit Category')}</h4>
                            <div className='mt-3'>
                                <div className="text-white text-center">{t('Thumpnail')}  </div>

                                <ImageUploader id={data.id} component={'PGroup'}></ImageUploader>

                            </div>


                            <form key={key} className='flex flex-col gap-5'>

                                <label className="text-white">{t('Name')} </label>
                                <input
                                    defaultValue={data.name}
                                    type="text"
                                    className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                    placeholder="Name"
                                    onChange={(e) => setData({ ...data, name: e.target.value })}
                                />
                                {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}


                                <label className="text-white"> Slug </label>
                                <input
                                    type="text"
                                    defaultValue={data.url}
                                    className={`${inputstyle}   ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                                    placeholder="Slug"
                                    onChange={(e) => setData({ ...data, url: e.target.value })}
                                />
                                {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}


                                <Button onClick={(e) => { save() }}>ذخیره سازی</Button>


                            </form>



                        </div>
                    </div>
                    <div className='col-span-1 sm:col-span-4 p-4 text-right' dir='rtl'>
                        <Tabs defaultActiveKey="1">
                            <Tabs.Tab eventKey="1" title="متن">
                                <TissEditor component='PGroup' parent={data.id} />
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="3" title="ویژگی ها">
                                <div className={`flex flex-col gap-3`}>
                                    <label>ويژگی ها</label>
                                    <TagInput
                                        defaultValue={data.feature}
                                        onChange={(e) => setData({ ...data, feature: e })}

                                        className='w-full' />
                                </div>
                            </Tabs.Tab>
                            <Tabs.Tab eventKey="2" title="سئو">
                                <div>
                                    <div className="flex flex-col gap-2">
                                        <label className="">{t('تیتر')}   </label>
                                        <Input
                                            defaultValue={data.title}
                                            className={inputstyle}
                                            onChange={(e) => setData({ ...data, title: e })}
                                            placeholder="..." />
                                        <label className="">{t('Description')}   </label>
                                        <Input
                                            as="textarea"
                                            rows={3}

                                            defaultValue={data.description}

                                            className={inputstyle}
                                            onChange={(e) => setData({ ...data, description: e })}
                                            placeholder="..." />

                                        <label className="">{t('Keywords')}   </label>
                                        <Input
                                            as="textarea"
                                            rows={3}

                                            defaultValue={data.keywords}

                                            className={inputstyle}
                                            onChange={(e) => setData({ ...data, keywords: e })}
                                            placeholder="..." />

                                        <label className="">{t('لیبل')}   </label>
                                        <Input
                                            defaultValue={data.label1}
                                            className={inputstyle}
                                            onChange={(e) => setData({ ...data, label1: e })}
                                            placeholder="..." />
                                        <label className="">{t('دیتا')}   </label>
                                        <Input
                                            defaultValue={data.data1}
                                            className={inputstyle}
                                            onChange={(e) => setData({ ...data, data1: e })}
                                            placeholder="..." />
                                    </div>
                                </div>
                            </Tabs.Tab>

                        </Tabs>

                    </div>
                </div>
            }

        </div>
    )
}